import {
    GET_MemberProfile,
    ADD_MemberProfile,
    TOGGLE_MemberProfile,
    RESET_MemberProfile,
    UPDATE_MemberProfile
  } from "../actionTypes";

const memberProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MemberProfile:
      return action.payload;

    case ADD_MemberProfile:
      return action.payload;

    case UPDATE_MemberProfile:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_MemberProfile:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_MemberProfile:
      return null;

    default:
      return state;
  }
};

export default memberProfileReducer;
